export default "__VITE_ASSET__Ccojfqox__"